var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetRepairAndRebuildAdministrationQuery } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
export default function RepairSeedUsers() {
    var t = useTranslation(["Administration"]).t;
    var _a = useState(false), isActivated = _a[0], setIsActivated = _a[1];
    var _b = useGetRepairAndRebuildAdministrationQuery({
        params: { action: "repairSeedUsers", type: isActivated },
    }), repairSeedUsers = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    var results = repairSeedUsers === null || repairSeedUsers === void 0 ? void 0 : repairSeedUsers.data;
    var resultsSeedUsers = repairSeedUsers === null || repairSeedUsers === void 0 ? void 0 : repairSeedUsers.data;
    var handleExcecute = function () {
        setIsActivated(function (prev) { return !prev; }); // Toggle activation status
        refetch(); // Refetch data after toggling
        resultsSeedUsers && toast.success(t(resultsSeedUsers[0]));
    };
    return (_jsxs("div", __assign({ className: "p-10 relative overflow-auto space-x-1" }, { children: [isLoading && _jsx(LoaderImage, {}), _jsxs("p", __assign({ className: "py-1" }, { children: [" ", t("LBL_REPAIR_SEED_USERS_TITLE")] })), _jsx("button", __assign({ onClick: handleExcecute, className: "button primary" }, { children: isActivated
                    ? t("LBL_REPAIR_SEED_USERS_ACTIVATE")
                    : t("LBL_REPAIR_SEED_USERS_DECACTIVATE") }))] })));
}
